import { useState, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Skeleton from "@mui/material/Skeleton";
import { Typography } from "@mui/material";
import useStyles from "./styles";

export default function CampoSimNao({
  name,
  index,
  value,
  fullWidth,
  sx,
  handleChange,
  label,
  size,
  enable,
  isLoading = false,
  required,
  descricao,
  autoFocus,
}) {
  const [isError, setIsError] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (required) setIsError(value === null || value === undefined);
  }, [value, required]);

  const handleChangeInternal = (event) => {
    const newValue = event.target.value === "true";
    handleChange({
      target: {
        name: name,
        value: newValue,
        checked: newValue, // mantém compatibilidade com o handleChangeCheck existente
      },
    });
  };

  return (
    <>
      {isLoading && (
        <Skeleton
          variant="rectangular"
          height={40}
          sx={sx}
          animation={false}
          className={classes.root}
        />
      )}
      {!isLoading && (
        <FormControl component="fieldset" disabled={!enable} fullWidth={fullWidth}>
          <FormLabel component="legend" error={isError}>
            {descricao}
            {required && " *"}
          </FormLabel>
          <RadioGroup
            row
            name={name}
            value={value === true ? "true" : value === false ? "false" : ""}
            onChange={handleChangeInternal}
          >
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Sim"
            />
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Não"
            />
          </RadioGroup>
        </FormControl>
      )}
    </>
  );
}